module.exports = __webpack_public_path__ + "media/images/ge-b86a7ee8c7b165996e07aca0d9ae7f2f.png";